export default {"src":"/_next/static/media/table_64.cad7f08a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};